import { useCallback } from 'react';

import {
  KommoNoteFieldsFragment,
  useKommoLeadNoteListQuery,
} from 'core/graphql';

import { ILeadError } from './leadsFeedback';
import { useLeadPermissions } from './useLeadPermissions';

/** ТЗ 0084 — примечания Kommo в карточке лида. */

export type IKommoNote = KommoNoteFieldsFragment;

const EMPTY_NOTES: IKommoNote[] = [];

/**
 * Примечания: из Kommo (вживую, кэш сервера 60 с) и наши, которых в Kommo
 * ещё нет. Kommo недоступен — `error`, а наши приходят всё равно: карточка
 * показывает и строку ошибки, и список.
 */
export const useKommoLeadNotes = (leadId: string | null, enabled = true) => {
  const { canUse } = useLeadPermissions();
  const { data, loading, error, refetch } = useKommoLeadNoteListQuery({
    variables: { leadId: leadId || '' },
    skip: !canUse || !enabled || !leadId,
    fetchPolicy: 'cache-and-network',
  });
  const notes = data?.kommoLeadNotes ?? null;
  const reload = useCallback(() => {
    refetch()?.catch(() => undefined);
  }, [refetch]);
  const kommoError: ILeadError | null = notes?.error
    ? { field: '', code: notes.error.code, message: notes.error.message }
    : null;
  return {
    notes: notes?.items ?? EMPTY_NOTES,
    kommoError,
    loading: loading && !notes,
    /** Упал сам запрос (сеть, права), а не Kommo. */
    failed: Boolean(error) && !notes,
    reload,
  };
};
